import * as React from "react";
import { forwardRef, Fragment, useState } from "react";
import { ProductResult } from "../../../../../microservices/functions/src/types/product_catalog/catalog_api_types";
import { CatalogItemBox } from "./catalog_item_box";
import ComparatorModal from "./comparator_message";

export type ProductsProps = {
  products: ProductResult[];
};

export const CatalogItemBoxList = React.memo(
  forwardRef<HTMLUListElement, ProductsProps>(
    ({ products }, ref): JSX.Element => {
      const [messageIsShown, setMessageIsShown] = useState(false);

      const hideMessage = () => {
        setMessageIsShown(false);
      };

      const refreshMessage = () => {
        setMessageIsShown(false);
        setTimeout(() => {
          setMessageIsShown(true);
        }, 150);
      };

      return (
        <Fragment>
          <ul className="cleaner product-list-lower" ref={ref}>
            {(products ?? []).map((product) => (
              <CatalogItemBox
                product={product}
                key={product.catalogId}
                onRefreshMessage={refreshMessage}
              />
            ))}
          </ul>
          {messageIsShown && <ComparatorModal onClose={hideMessage} />}
        </Fragment>
      );
    }
  )
);
